import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import ReportHeader from "./ReportHeader";
import ReportFooter from "./ReportFooter";
import ReportHeader_Swiss from "./ReportHeader_Swiss";
import ReportFooter_Swiss from "./ReportFooter_Swiss";
import PropTypes from "prop-types";

export class ReportPaintImages extends Component {
  lang = (word) => {
    const { lang, words } = this.props;
    return words[word] ? words[word][lang] : word;
  };

  render() {
    const { paintImageArray, isPaintImage } = this.props;
    return (
      <>
        {isPaintImage && paintImageArray.map((data, i) => {
          return (
            <div
              className="row row-zero page-break-row report-full-wrapper"
              data-content-name={this.lang("Page")}
            >
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container">
                        <div className="row title-row-main">
                          <div className="col-sm-12 col-zero">
                            <h3 className="report-title">
                              {this.lang("Lak")}{" "}
                              <span>{this.lang("Images")}</span>
                            </h3>
                          </div>
                        </div>
                        <div className="all_photo_images">
                          {data.map((inner_data, i) => {
                            return (
                              <React.Fragment key={i}>
                                <div className="row left-side-row">
                                  {inner_data.map((r, i) => {
                                    return r ? (
                                      <div className="col-lg-6 col-md-6 col-sm-12 col-zero">
                                        <div className="row row-zero photo_gallery_border_row">
                                          <div className="col-sm-12 photo_gallery_border_col">
                                            <div className="photo_gallery_img">
                                              <img alt="" src={r} />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null;
                                  })}
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss reportType="newReportFull" />
                </Card>
              </div>
            </div>
          );
        })}
      </>
    );
  }
}

export default ReportPaintImages;
